import { useHook } from '../lenteHooks'
import { useAvailableComponentsForTenant } from './useAvailableComponentsForTenant'

/*
 *  This hook is a wrapper around useAvailableComponentsForTenant that
 *   use DI to obtain the tenantId and passes the tenantId as a prop.
 */

export const useAvailableComponents = () => {
  const tenantId = useHook('routing.tenant.useTenantParam')({
    isOptional: true,
  })
  return useAvailableComponentsForTenant(tenantId)
}
